<template>
  <span class="action-button">
    <template v-if="readonly">
      <span class="caption ml-2 mr-2 d-inline-block pl-2 pr-2">
        <v-icon
          v-if="buttonIcon!==''"
          class="d-inline-block"
          :color="buttonIconColor"
        >{{ buttonIcon }}</v-icon>
        <span
          :class="['d-inline-block','action-button-readonly-text', textClass]"
          style="position:relative; top:2px"
        >{{ buttonText }}</span>
      </span>
    </template>
    <template v-else>
      <v-tooltip
        :disabled="disabledTooltip"
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-hover>
            <v-btn
              slot-scope="{ hover }"
              :fab="isFab"
              v-bind="buttonBind(hover)"
              :disabled="disabled"
              text
              small
              rounded
              class="pl-2 pr-2"
              v-on="on"
              @click="buttonClick"
            >
              <template v-if="hasSlot('button')">
                <slot name="button" />
              </template>
              <template v-else>
                <v-icon
                  v-if="buttonIcon!==''"
                  :left="buttonText!==''"
                  :color="hover?buttonIconColorHover:buttonIconColor"
                >{{ buttonIcon }}</v-icon>
                <span
                  v-if="buttonText!==''"
                  :class="['action-button-text', textClass]"
                >{{ buttonText }}</span>
              </template>
            </v-btn>
          </v-hover>
        </template>
        <v-layout>
          <v-flex
            v-if="tooltipIcon!==''||hasSlot('tooltip-icon')"
            xs2
          >

            <template v-if="hasSlot('tooltip-icon')">
              <slot name="tooltip-icon" />
            </template>
            <template v-else>
              <v-icon
                :color="tooltipIconColor"
                left
              >{{ tooltipIcon }}
              </v-icon>
            </template>
          </v-flex>
          <v-flex :class="{xs10:tooltipIcon!=='',xs12:tooltipIcon===''}">
            <template v-if="hasSlot('tooltip-text')">
              <slot name="tooltip-text" />
            </template>
            <template v-else>
              {{ tooltipText }}
            </template>
          </v-flex>
        </v-layout>
      </v-tooltip>
    </template>
  </span>
</template>

<script>
export default {
  name: 'ActionButton',
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    to: {
      type: [Object, String, Boolean],
      default: false
    },
    buttonText: {
      type: [Number, String],
      default: ''
    },
    buttonIcon: {
      type: String,
      default: ''
    },
    buttonIconColor: {
      type: String,
      default: 'black'
    },
    buttonIconColorHover: {
      type: String,
      default: 'primary'
    },
    tooltipText: {
      type: String,
      default: ''
    },
    tooltipIcon: {
      type: String,
      default: ''
    },
    tooltipIconColor: {
      type: String,
      default: 'black'
    },
    textClass: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  computed: {
    isFab () {
      return this.buttonText === ''
    },
    buttonBind () {
      return (hover) => {
        let result = {
          class: ['text-none', 'ma-0', 'pa-0', 'elevation-' + (hover ? 2 : this.backgroundColor === 'transparent' ? 0 : 1)],
          style: {
            backgroundColor: hover ? '#ffffff' : this.backgroundColor
          }
        }

        if (!hover && this.buttonText !== '') {
          result.class.push('action-button-underscored')
        }

        if (this.to !== false) {
          result.to = this.to
        }

        return result
      }
    },
    disabledTooltip () {
      if (!this.hasSlot('tooltip-text') && (!this.tooltipText || this.tooltipText === '')) {
        return true
      }
      return false
    }
  },
  methods: {
    hasSlot (name) {
      return !!this.$slots[name] || !!this.$scopedSlots[name]
    },
    buttonClick (event) {
      this.$emit('click', event)
    }
  }
}
</script>
<style>
    .action-button-readonly-text {
        position: relative;
        top: -5px;
        left: 5px;
    }

    .action-button .action-button-underscored .action-button-text {
        text-decoration: underline;
    }
</style>
